import React from "react"
import { makeStyles } from "@material-ui/core"

const TextFieldIconSeparator = () => {
    const classes = useStyles();

    return (
        <div className={classes.iconSeparator}></div>
    );
};

const useStyles = makeStyles((theme) => ({
    iconSeparator: {
        backgroundColor: "hsl(0,0%,80%)",
        margin: "8px 0px",
        height: "38px",
        width: "1px",
    }
}))

export default TextFieldIconSeparator;
